export const CHANNELMENUS_MP_KEY = 'channelmenus_mp';
